import { AgentTrace } from '@/pages/AgentTrace/AgentTrace';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

/** `?run=<agentInvocationId>&hop=<hopIndex>` — a permalink to one run of the trigger, and one hop of it. */
const TraceSearchSchema = z.object({
  run: z.string().min(1).optional(),
  hop: z.coerce.number().int().min(0).optional(),
});

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { triggerType, triggerId } = Route.useParams();
  // oxlint-disable-next-line no-use-before-define
  const search = Route.useSearch();
  // oxlint-disable-next-line no-use-before-define
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <AgentTrace
      triggerType={triggerType}
      triggerId={triggerId}
      search={search}
      onSearchChange={(patch) => {
        // `replace` so stepping through hops does not bury the page the reader came from.
        void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true });
      }}
    />
  );
};

export const Route = createFileRoute('/_auth/internal/agent-trace/$triggerType/$triggerId')({
  component: RouteComponent,
  loader: () => ({ crumb: 'AI trace' }),
  validateSearch: TraceSearchSchema,
});
